import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ApplyButtonProps {
  className?: string;
  inverted?: boolean;
  text?: string;
}
export function ApplyButton({
  className = '',
  inverted = false,
  text = 'Apply Now'
}: ApplyButtonProps) {
  const baseStyles = 'group inline-flex items-center justify-center px-8 py-4 text-sm tracking-editorial uppercase transition-all duration-500 ease-out border';
  const variants = inverted ? 'bg-cream text-ink border-cream rounded-full hover:bg-transparent hover:text-cream' : 'bg-ink text-cream border-ink rounded-full hover:bg-transparent hover:text-ink';
  return <a href="https://whop.com/joined/hemma-92b9/" target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants} ${className}`} data-id="element-1">
      <span data-id="element-2">{text}</span>
      <ArrowRightIcon className="ml-2 h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" data-id="element-3" />
    </a>;
}